import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

let messages = {
    pl: {
        language: "Język",
        pharmacies: "Apteki",
        wholesalers: "Hurtownie",
        hospitals: "Szpitale",
        contact: "Kontakt",
        sections: {
            navbarTop: {
                language: "Język"
            }
        },
        pages: {
            home: {
                about: {
                    title: "O IQVIA",
                    content: '\
                        <p>\
                            IQVIA (NYSE:Q) jest wiodącym, globalnym dostawcą zintegrowanych informacji oraz wspieranych przez rozwiązania technologiczne \
                            usług w obszarze ochrony zdrowia, które umożliwiają klientom osiągnięcie lepszych wyników w obszarze klinicznym, naukowym oraz komercyjnym. \
                            Powstała w rezultacie połączenia firm Quintiles oraz IMS Health, IQVIA zatrudnia ok. 50 000 pracowników w ponad stu krajach. \
                            Firmy poszukujące sposobów podniesienia efektywności terapii oraz wzbogaconych badań klinicznych dostępnych w formie outsourcingu, \
                            mogą wykorzystać szeroką gamę rozwiązań IQVIA w zakresie informacji, technologii i usług, tak aby wykreować nową wiedzę i sposoby działania.\
                        </p>\
                        <p>\
                            IQVIA dostarcza rozwiązania, które znajdują szerokie zastosowanie – od badań klinicznych, aż po działania komercyjne – \
                            umożliwiając klientom pełne wykorzystanie potencjału ich innowacji i poprawy wyników w obszarze ochrony zdrowia pacjentów.\
                        </p>\
                        <p>\
                            Jako globalny lider w zakresie ochrony tajemnicy informacji dotyczących indywidualnych pacjentów, \
                            IQVIA wykorzystuje zanonimizowane dane z obszaru ochrony zdrowia, aby stworzyć rzeczywisty obraz schorzeń oraz prowadzonych terapii. \
                            Dzięki szerokiej gamie rozwiązań technologicznych, IQVIA chroni poufność danych i prywatność indywidualnych pacjentów, \
                            jednocześnie tak zarządzając informacjami, aby wspierały proces usprawniania opieki zdrowotnej. \
                            Wiedza ta oraz umiejętność jej wykorzystania pomagają firmom biotechnologicznym i farmaceutycznym, przedstawicielom nauk medycznych, agencjom rządowym, \
                            płatnikom oraz innym interesariuszom sektora ochrony zdrowia rozwijać oraz stosować nowe terapie, identyfikować niezaspokojone potrzeby terapeutyczne \
                            oraz lepiej zrozumieć bezpieczeństwo, skuteczność i wartość produktów farmaceutycznych w celu uzyskania poprawy efektów zdrowotnych. \
                            Dodatkowe informacje znajdują się pod adresem <a href="http://www.IQVIA.com" target="_blank">www.IQVIA.com</a>.\
                        </p>\
                    '
                },
                clients: {
                    title: "Partnerzy",
                    content: '',
                    forward: "Przejdź",
                    elements :{
                        pharmacies: {
                            name: "Apteki",
                            content: "\
                                Nasze wysokie standardy bezpieczeństwa danych doceniają zarówno partnerzy sieciowi jak i apteki indywidualne.\
                                Zaufało nam już 6000 aptek, które od lat wspieramy raportami pozwalającymi na lepsze rozumienie zmian na rynku \
                                oraz dostosowywanie swych działań do zmieniających się warunków.\
                            "
                        },
                        wholesalers: {
                            name: "Hurtownie",
                            content: "\
                                Współpracujemy z Hurtowniami Farmaceutycznymi – podmiotami (dystrybutorami, producentami, importerami)\
                                zajmującymi się zapewnianiem produktów rynku ochrony zdrowia dla aptek, szpitali i innych uprawnionych odbiorców.\
                            "
                        },
                        hospitals: {
                            name: "Szpitale",
                            content: "Pomagamy w zarządzaniu Szpitalem. Przygotowujemy analizy benchmarkowe oraz zestaw raportów dla dyrektorów szpitali."
                        }
                    }
                }
            },
            clients: {
                pharmacies: {
                    title: "Apteki",
                    about: '\
                        <p>\
                            IQVIA współpracuje z aptekami na zasadzie dobrowolnej wymiany danych. Dane z aptek dotyczące sprzedaży,\
                            zakupów i stanów magazynowych są przekazywane do IQVIA w oparciu o sprawdzoną aplikację, która nie ma wpływu\
                            na działalność apteki.\
                        </p>\
                        <p>\
                            W ramach współpracy apteka otrzymuje comiesięczny raport, który dostarcza istotnych informacji umożliwiających\
                            efektywne zarządzanie apteką. Raporty zawierają również informacje dotyczące rynku, na którym funkcjonuje apteka,\
                            co pozwala na porównania i właściwą ocenę wyników sprzedażowych apteki. Umożliwia to pełne wykorzystanie szans i\
                            możliwości, które stwarza rynek.\
                        </p>\
                        <p>\
                            Dzięki raportom IQVIA można dokonać porównania wyników własnych apteki do średnich wyników na poziomie powiatu,\
                            jak również dokonać oceny przyjętej polityki cenowej czy zakupowej.\
                        </p>\
                    ',
                    products: {
                        title: "Nasze produkty",
                        content: "\
                            Począwszy od 2017 roku wdrożyliśmy nowy system raportowania poprzez platformę online. \
                            W naszej ofercie mamy dwa oddzielne rozwiązania dedykowane dla grupy aptek - Platforma Sieci Aptek, \
                            lub dla aptek indywidualnych – Centrum Informacji Aptecznej. Zachęcamy do zapoznania się z filmami prezentującymi funkcjonalność obydwu rozwiązań.\
                        ",
                        items: {
                            cia: {
                                name: 'Centrum Informacji Aptecznej',
                                description: ''
                            },
                            psa: {
                                name: 'Platforma Sieci Aptek',
                                description: ''
                            }
                        }

                    },
                    cooperation: {
                        title: "Zapraszamy do współpracy",
                        raportownik: "Pobierz raportownik",
                        content: "\
                            <p>\
                                Jeżeli zarządzają Państwo <strong>apteką indywidualną</strong>, zapraszamy do kontaktu z naszymi przedstawicielami, \
                                którzy szczegółowo przeprowadzą Państwa przez proces przygotowania umowy i \
                                instalacji oprogramowania raportującego.\
                            </p>\
                        ",
                        voivodships: "Województwa:",
                        contact: "\
                            <p>\
                                Jeżeli są Państwo zainteresowani współpracą, prosimy o kontakt z <strong>Magdaleną Marciniak</strong>, Associate Director, Supplier Relations.\
                            </p>\
                            <p>\
                                Kontakt: magdalena.marciniak@iqvia.com, kom. +48 603 875 703\
                            </p>\
                        "
                    },
                },
                wholesalers: {
                    title:"Hurtownie",
                    about:"\
                        <p>\
                            Współpracujemy z Hurtowniami Farmaceutycznymi – podmiotami (dystrybutorami, producentami, importerami) \
                            zajmującymi się zapewnianiem produktów rynku ochrony zdrowia dla aptek, szpitali i innych uprawnionych odbiorców.\
                        </p>\
                    ",
                    products: {
                        title: "Produkty",
                        content: "\
                            <p>\
                                Dzięki współpracy z IQVIA hurtownie uzyskują szerszą wiedzę o rynku na którym działają.\
                            </p>\
                            <p>\
                                Mnogość raportów zwrotnych różnego typu i zawartości pozwala na precyzyjne określenie działalności hurtowni na tle rynku \
                                (aptecznego, szpitalnego), jak również obserwowania zmian, dynamik, ewolucji.\
                            </p>\
                        "
                    },
                    platform: {
                        title: "Platforma hurtowa",
                        content: "\
                            <p>\
                                O platformie.\
                            </p>\
                        "
                    },
                    contact: {
                        title: "Kontakt",
                        content: "\
                            <p>\
                                Osoba odpowiedzialna za relację z hurtowniami:\
                            </p>\
                            <p>\
                                <strong>Robert Sujak</strong>\
                            </p>\
                            <p>\
                                Manager, Supplier Services\
                            </p>\
                        ",
                    }
                },
                hospitals: {
                    title:"Szpitale",
                    about:"\
                        <p>\
                            <strong>Nawiąż z nami współpracę</strong>\
                        </p>\
                        <p>\
                            W celu nawiązania współpracy prosimy o kontakt.\
                        </p>\
                    ",
                    project: {
                        title: "Projekt szpitalny",
                        content: "\
                            <p>\
                                Głównym celem projektu jest uzyskanie możliwości analizy danych szpitalnych zawierających podstawowe, sprawozdawcze, \
                                statystyczne, nieodwracalnie zanonimizowane dane powiązane z indywidualnym pacjentem oraz ich połączenie z bazą danych lecznictwa \
                                otwartego (LRx, IMS). Poprzez zastosowanie tego samego numeru identyfikacyjnego (zanonimizowanego) pacjenta możliwe stanie \
                                się monitorowanie ścieżek pacjentów w lecznictwie zamkniętym i otwartym jako odzwierciedlenie schematów diagnostycznych i leczniczych.\
                            </p>\
                            <p>\
                                <strong>Analizy benchmarkowe pozwolą na porównanie konkretnej placówki z grupą podobnych podmiotów przez pryzmat wykonanych procedur, rozpoznań głównych i dodatkowych, JGP. \
                                Możliwe staną się analizy długości hospitalizacji z uwzględnieniem typów oddziałów i stopni referencyjności szpitali.</strong>\
                            </p>\
                            <p>\
                                Dokładne dane dotyczące leczenia farmakologicznego pozwolą na ocenę compliance i persistance przed i po okresie hospitalizacji, \
                                dane szpitalne na analizę zjawiska („szybkiej”) rehospitalizacji, poważnych działań niepożądanych zakończonych hospitalizacją, monitorowanie \
                                dawek leków, zjawiska polipragmazji. Tak zebrane informacje będą stanowić punkt wyjścia do oceny (raportowanej) sytuacji epidemiologicznej, \
                                monitorowania zużytych zasobów, w tym leków i wyrobów medycznych, przeprowadzania analiz kosztów oraz kosztów choroby. \
                                Przy założeniu pozyskania danych z dużej, reprezentatywnej próby możliwe będzie wykonywanie analiz porównawczych skuteczności \
                                i kosztowej efektywności technologii lekowych i nie-lekowych np. zabiegów operacyjnych. Stopień szczegółowości analiz będzie zależał \
                                od zakresu przetwarzanych danych. Ze względu na globalny zasięg działalności IQVIA, możliwe będą porównania międzynarodowe.\
                            </p>\
                        ",
                    },
                    contact: {
                        title: "Kontakt",
                        raportownik: "Pobierz raportownik",
                        content: "\
                            <p>\
                                Jeżeli jesteście Państwo zainteresowani współpracą w zakresie zarządzania szpitalem, prosimy o kontakt:\
                            </p>\
                            <p>\
                                <strong>Marcin Gawroński</strong>\
                            </p>\
                            <p>\
                            Associate Director, Supplier Relations, Poland & Baltics\
                            </p>\
                            <p>\
                                marcin.gawronski@iqvia.com\
                            </p>\
                        ",
                    }
                }
            },
            contact: {
                title: "Kontakt",
                about: '\
                    <p>\
                        Jeżeli chcieliby Państwo uzyskać dodatkowe informacje lub nawiązać z nami współpracę,\
                        prosimy o kontakt na adres: serwis_pl@iqvia.com lub też kontakt telefoniczny na numer +48 22 389 1000.\
                    </p>\
                ',
                location: {
                    title: "Lokalizacja",
                    street: "ul. Domaniewska 48",
                    city: "02-672 Warszawa",
                    country: "Polska",
                }
            }
        }
    },
    en: {
        language: "Language",
        pharmacies: "Pharmacies",
        wholesalers: "Wholesalers",
        hospitals: "Hospitals",
        contact: "Contact",
        sections: {
            navbarTop: {
                language: "Language"
            }
        },
        pages: {
            home: {
                about: {
                    title: "About IQVIA",
                    content: '\
                        <p>\
                            IQVIA (NYSE:Q) is a leading integrated information and technology-enabled healthcare service provider worldwide, \
                            dedicated to helping its clients improve their clinical, scientific and commercial results. \
                            Formed through the merger of Quintiles and IMS Health, IQVIA’s approximately 50,000 employees conduct operations in more than 100 countries. \
                            Companies seeking to improve real-world patient outcomes and enhanced clinical trial outsourcing through treatment innovations, \
                            care provision and access can leverage IQVIA’s broad range of healthcare information, technology and service solutions to drive \
                            new insights and approaches.\
                        </p>\
                        <p>\
                            IQVIA provides solutions that span clinical to commercial bringing clients a unique opportunity to realize the full potential \
                            of innovations and advance healthcare outcomes.\
                        </p>\
                        <p>\
                            As a global leader in protecting individual patient privacy, IQVIA uses healthcare data to deliver critical, \
                            real-world disease and treatment insights. Through a wide variety of privacy-enhancing technologies and safeguards, \
                            IQVIA protects individual privacy while managing information to drive healthcare forward. \
                            These insights and execution capabilities help biotech, medical device, and pharmaceutical companies, medical researchers, \
                            government agencies, payers and other healthcare stakeholders in  the development and approval of new therapies, \
                            identify unmet treatment needs and understand the safety, effectiveness and value of pharmaceutical products in improving overall health outcomes. \
                            To learn more, visit <a href="http://www.IQVIA.com" target="_blank">www.IQVIA.com</a>.\
                        </p>\
                    '
                },
                clients: {
                    title: "Partners",
                    content: '',
                    forward: "Forward",
                    elements :{
                        pharmacies: {
                            name: "Pharmacies",
                            content: "\
                                Our high standards of data security are appreciated by both network partners and individual pharmacies.\
                                We have already trusted 6000 pharmacies, which for years have been supporting reports that allow us \
                                to better understand market developments and adapt our actions to changing conditions.\
                                We are currently implementing business solutions for our Partners unique on a global scale.\
                                We invite you to get acquainted with the details.\
                            "
                        },
                        wholesalers: {
                            name: "Wholesalers",
                            content: "\
                                We cooperate with Pharmaceutical Wholesalers - entities (distributors, manufacturers, importers)\
                                Those involved in providing healthcare products to pharmacies, hospitals and other legitimate customers.\
                            "
                        },
                        hospitals: {
                            name: "Hospitals",
                            content: "We help in managing the Hospital. We prepare benchmark analyzes and a set of reports for hospital directors."
                        }
                    }
                }
            },
            clients: {
                pharmacies: {
                    title: "Pharmacies",
                    about: '\
                        <p>\
                            IQVIA, cooperates with pharmacies on a voluntary exchange of data. \
                            Sales, purchases, and stock data from pharmacies are forwarded to IQVIA based on a proven application that does not interfere \
                            with the normal operation of the pharmacy.\
                        </p>\
                        <p>\
                            Within the framework of the co-operation, the Pharmacy receives a monthly report containing a number of information relevant \
                            to the effective management of the pharmacy. While a pharmacist working with pharmacy data knows what is inside the Pharmacy \
                            and how to manage current needs, without having a reference to the market in which it operates, \
                            it is unable to fully exploit the opportunities and opportunities that the market offers. \
                            Unmatched by the environment, it is difficult to determine whether the observed increase in sales is a success, \
                            as competition has been able to capitalize on opportunities and grow more. Also, without the background, \
                            it is difficult to estimate whether a drop in sales observed at home is a problem in a pharmacy, or whether it is also about competition.\
                        </p>\
                        <p>\
                            With IQVIA reports, you can compare your own results to the county as well as revise your pricing or purchasing policy. \
                            However, keep in mind that we offer you a tool and not a ready-made solution, and without knowingly running a pharmacy the report alone \
                            is not enough to increase your profits.\
                        </p>\
                    ',
                    products: {
                        title: "Our products",
                        content: "\
                            Starting in 2017, we started implementing a new report model, the online platform. \
                            In our offer we have two separate solutions dedicated to the group of pharmacies - CPS, \
                            or for individual pharmacy - SPS. \
                            This is a world-class solution that will be available in many European countries. We encourage you to get acquainted with promotional videos.\
                        ",
                        items: {
                            cia: {
                                name: 'SPS',
                                description: ''
                            },
                            psa: {
                                name: 'CPS',
                                description: ''
                            }
                        }

                    },
                    cooperation: {
                        title: "Make contact with us",
                        raportownik: "Download IQVIA Service",
                        content: "\
                            <p>\
                                If you run an individual pharmacy to collaborate, you should contact our agents who will guide you through the entire process \
                                of contract preparation, installation of reporting software, and answers to frequently asked questions.\
                            </p>\
                        ",
                        voivodships: "Voivodships:",
                        contact: "\
                            <p>\
                                If you manage a group of pharmacies, please contact our reception +48 22 389 1000\
                            </p>\
                        "
                    },
                },
                wholesalers: {
                    title:"Wholesalers",
                    about:"\
                        <p>\
                            We cooperate with Pharmaceutical Wholesalers - companies (distributors, manufacturers, importers) \
                            dealing with the provision of healthcare products to pharmacies, hospitals and other authorized customers.\
                        </p>\
                    ",
                    products: {
                        title: "Products",
                        content: "\
                            <p>\
                                Thanks to cooperation with IQVIA, wholesalers gain a wider knowledge of the market in which they operate.\
                            </p>\
                            <p>\
                                A multitude of different types of feedback reports and content allows you for precise determination of wholesaler \
                                position on the market (pharmacy, hospital), as well as observing changes, dynamics, evolution.\
                            </p>\
                        "
                    },
                    platform: {
                        title: "Platform",
                        content: "\
                            <p>\
                                About\
                            </p>\
                        "
                    },
                    contact: {
                        title: "Contact",
                        content: "\
                            <p>\
                                The person responsible for the relationship with wholesalers:\
                            </p>\
                            <p>\
                                <strong>Robert Sujak</strong>\
                            </p>\
                            <p>\
                                Manager, Supplier Services\
                            </p>\
                        ",
                    }
                },
                hospitals: {
                    title:"Hospitals",
                    about:"\
                        <p>\
                            <strong>Make contact with us</strong>\
                        </p>\
                        <p>\
                            Please contact us for cooperation.\
                        </p>\
                    ",
                    project: {
                        title: "Hospital project",
                        content: "To see a description of the project, launch the Polish language version",
                    },
                    contact: {
                        title: "Contact",
                        content: "\
                            <p>\
                                If you are interested in cooperation in hospital management please contact:\
                            </p>\
                            <p>\
                                <strong>Marcin Gawroński</strong>\
                            </p>\
                            <p>\
                                Associate Director, Supplier Relations, Poland & Baltics\
                            </p>\
                            <p>\
                                marcin.gawronski@iqvia.com\
                            </p>\
                        ",
                        raportownik: "Download IQVIA Service",
                    }
                }
            },
            contact: {
                title: "Contact",
                about: '\
                    <p>\
                        If you are interested in our offer, or would like to get detailed information about our products and services,\
                        please feel free to contact us by phone, email or in person at our office. We are at your disposal from 9am to 5pm Monday to Friday.\
                    </p>\
                ',
                location: {
                    title: "Location",
                    street: "Domaniewska 48 Street",
                    city: "02-672 Warsaw",
                    country: "Poland",
                }
            }
        }
    }
}

export default new VueI18n({
  locale: 'pl',
  messages
});



// WEBPACK FOOTER //
// ./src/locales.js